/**
 * @file index.tsx
 *
 * @fileoverview Renders blog call to action row.
 */

import { LinkItem } from '~/jobiqo/types/types';
import Link from '~/jobiqo/components/Link';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';
import { Hr } from '~/vcl/atoms/06-layout/10-hr';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import { LinkButton } from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import NextLink from 'next/link';

interface BlogCTARowProps {
  /*
   * The button link.
   */
  button: LinkItem;
  /**
   * The position.
   */
  position: 'left' | 'right' | 'center';
  /**
   * The description.
   */
  description?: string;
}
export default function BlogCTARow({
  button,
  description,
  position,
}: BlogCTARowProps) {
  let flexDirection: 'row' | 'row-reverse' | 'column' = 'row';

  if (position === 'left') {
    flexDirection = 'row-reverse';
  } else {
    if (position === 'center') {
      flexDirection = 'column';
    }
  }

  return (
    <>
      <Hr />
      <Spacing padding={5}>
        <FlexItems
          flexDirection={['column', flexDirection as any]}
          gap={7}
          alignItems="center"
        >
          {description && (
            <FlexItem flex={3}>
              <WYSIWYGText content={description} format="full_html" />
            </FlexItem>
          )}
          <FlexItem {...(description && { mt: 6 })}>
            {button?.url && (
              <Link asChild>
                <LinkButton
                  linkElement={NextLink}
                  {...getFormattedPageLink(button.url)}
                  buttonStyle="primary"
                >
                  {button.text}
                </LinkButton>
              </Link>
            )}
          </FlexItem>
        </FlexItems>
      </Spacing>
      <Hr />
    </>
  );
}
export { BlogCTARow };
